<!-- Begin: Admin Form -->
<div class="mw1000 center-block">
    <div class="admin-form">

        <div class="panel heading-border">
            <div class="panel-body bg-light">
                <form ngNativeValidate [formGroup]="forma" (ngSubmit)="updateUser()" method="post" id="form-ui">
                    <div class="section-divider mb40" id="spy1">
                        <span>Edit User</span>
                    </div>
                    <!-- .section-divider -->

                    <!-- Basic Inputs -->
                    <div class="row">
                        <div class="col-md-4">
                            <img *ngIf="urlImg" [src]="urlImg" style="width: 100%; height: 285px;" class="img-thumbnail rounded " />


                            <div class="section">
                                <label class="field prepend-icon file">
                              <span class="button">Choose File</span>
                              <input type="file" class="gui-file" name="file2" id="file2" (change)="cambioArchivo($event)"><!--"-->
                              <input type="text" class="gui-input" id="uploader3" placeholder="Please Select A File">
                              <label class="field-icon">
                                <i class="fa fa-upload"></i>
                              </label>
                                </label>
                                <div *ngIf="activo" class="progress" style="height: 20px;">
                                    <div class="progress-bar progress-bar-primary" role="progressbar" [ngStyle]="{ width: total + '%' }" attr.aria-valuenow=" {{ total }} " aria-valuemin="0" aria-valuemax="100">
                                        {{ total }} %
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8 ">
                            <div class="row ">
                                <div class="col-md-6 ">
                                    <div class="section ">

                                        <mat-form-field class="example-full-width">
                                          <mat-label>Firstname</mat-label>
                                          <input matInput formControlName="firstname" name="firstname" id="firstname" >
                                          <mat-icon matSuffix> person </mat-icon>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-6 ">
                                    <div class="section ">


                                        <mat-form-field class="example-full-width">
                                          <mat-label>Lastname</mat-label>
                                          <input matInput formControlName="lastname" name="lastname" id="lastname">
                                          <mat-icon matSuffix> person </mat-icon>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">

                                    <div class="section ">

                                      <mat-form-field class="example-full-width">

                                        <mat-label>Id</mat-label>

                                        <input matInput type="number" placeholder="Id"  formControlName="identification">
                                        <mat-icon matSuffix> portrait </mat-icon>



                                      </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="section ">
                                      <mat-form-field class="example-full-width">
                                        <mat-label>
                                          Email
                                        </mat-label>
                                        <input matInput formControlName="email" name="email" id="email">
                                        <mat-icon matSuffix> email </mat-icon>

                                        <mat-error   *ngIf="forma.controls['email'].invalid && forma.touched">
                                          You must write your  <strong> Email</strong>
                                      </mat-error>

                                      </mat-form-field>


                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="section ">
                                      <mat-form-field class="example-full-width">
                                        <mat-label>Password</mat-label>

                                        <input matInput placeholder="Password" [type]="hide ? 'password' : 'text'" formControlName="password" required>
                                        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                      </mat-form-field>


                                        <mat-error   *ngIf="forma.controls['password'].invalid && forma.touched">
                                          <strong> Password </strong> is required
                                    </mat-error>

                                    </div>

                                </div>
                                <div class="col-md-6">
                                    <div class="section ">
                                      <mat-form-field class="example-full-width">
                                        <mat-label>Confirm Password</mat-label>

                                        <input matInput placeholder="Password" [type]="hide ? 'password' : 'text'" formControlName="password2" required>
                                        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>

                                        <mat-error  *ngIf="forma.errors?.samePassword">
                                          <strong>  Password you must same</strong>
                                       </mat-error>

                                      </mat-form-field>

                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="section ">
                                      <mat-form-field class="example-full-width">
                                        <mat-label>Phone</mat-label>

                                        <input matInput type="number" placeholder="Phone"  formControlName="phone">
                                        <mat-icon matSuffix> phone </mat-icon>
                                       <!--
                                         <mat-select formControlName="typeuser" formControlName="typeuser" name="typeuser" >

                                          <mat-option value=" ">Select Role</mat-option>
                                          <mat-option value="AL">AL</mat-option>
                                          <mat-option value="AD">UAD</mat-option>
                                          <mat-option value="AM">AMS</mat-option>

                                        </mat-select>

                                        <mat-error *ngIf="forma.controls.typeuser.hasError('required')">You must make a selection</mat-error> -->

                                      </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-6 ">

                                        <div class="section">
                                          <mat-form-field class="example-full-width">

                                            <mat-label>Select Role</mat-label>

                                            <!--(selectionChange)="selectCustomer($event)"-->
                                            <mat-select formControlName="role" formControlName="role" name="role" >

                                              <mat-option value=" ">Select Role</mat-option>
                                              <mat-option value="1">Admin</mat-option>
                                              <mat-option value="2">User</mat-option>
                                              <mat-option value="3">Driver</mat-option>

                                            </mat-select>

                                            <mat-error *ngIf="forma.controls.role.hasError('required')">You must make a selection</mat-error>


                                          </mat-form-field>

                                    </div>



                                </div>
                            </div>

                            <div class="row">

                                <div class="col-md-6">

                                    <mat-form-field class="example-full-width">
                                    <mat-label>Status</mat-label>
                                    <mat-select formControlName="status">

                                        <mat-option value="0">Inactive </mat-option>
                                        <mat-option value="1">Active  </mat-option>
                                    </mat-select>

                                    <mat-error *ngIf="forma.controls.status.hasError('required')">You must make a selection</mat-error>
                                  </mat-form-field>

                                </div>

                            </div>

                            <div class="row">
                                <div class="col-md-12">


                                  <mat-form-field class="example-full-width">
                                    <mat-label>Leave a comment</mat-label>
                                    <textarea matInput placeholder="Description by delivery..." formControlName="description" id="description" name="description" rows=5></textarea>
                                  </mat-form-field>


                                </div>

                            </div>

                            <div class="row">


                            </div>

                        </div>
                    </div>










                    <!--   <div class="section-divider mt40 mb25 " id="spy6 ">
                      <span>Toggle Switches</span>
                  </div>


                  <div class="section row ">
                      <div class="col-md-6 col-md-3 ">
                          <label class="switch block mt15 ">
<input type="checkbox " name="features " id="f1 " value="javascript ">
<label for="f1 " data-on="ON " data-off="OFF "></label>
                          <span>Javascript</span>
                          </label>
                          <label class="switch block mt15 ">
<input type="checkbox " name="features " id="f2 " value="downloads ">
<label for="f2 " data-on="ON " data-off="OFF "></label>
                          <span>Downloads</span>
                          </label>
                          <label class="switch block mt15 ">
<input type="checkbox " name="features " id="f3 " value="cookies ">
<label for="f3 " data-on="ON " data-off="OFF "></label>
                          <span>Cookies</span>
                          </label>
                          <label class="switch block mt15 ">
<input type="checkbox " name="features " id="f4 " value="popups " checked>
<label for="f4 " data-on="ON " data-off="OFF "></label>
                          <span>Popups</span>
                          </label>
                      </div>


                      <div class="hidden-xs col-md-3 ">
                          <label class="switch block mt15 ">
<input type="checkbox " name="tools " id="t1 " value="analytics ">
<label for="t1 " data-on="YES " data-off="NO "></label>
                          <span>Analytics</span>
                          </label>
                          <label class="switch block mt15 ">
<input type="checkbox " name="tools " id="t2 " value="reports ">
<label for="t2 " data-on="YES " data-off="NO "></label>
                          <span>Reports</span>
                          </label>
                          <label class="switch block mt15 ">
<input type="checkbox " name="tools " id="t3 " value="social ">
<label for="t3 " data-on="YES " data-off="NO "></label>
                          <span>Social</span>
                          </label>
                          <label class="switch block mt15 ">
<input type="checkbox " name="tools " id="t4 " value="admin " checked>
<label for="t4 " data-on="YES " data-off="NO "></label>
                          <span>Access</span>
                          </label>
                      </div>


                      <div class="col-md-6 col-md-3 ">
                          <label class="switch switch-round block mt15 ">
<input type="radio " name="framework " id="fr1 " value="mootols ">
<label for="fr1 " data-on="ON " data-off="OFF "></label>
                          <span>MooTools</span>
                          </label>
                          <label class="switch switch-round block mt15 ">
<input type="radio " name="framework " id="fr2 " value="angular ">
<label for="fr2 " data-on="ON " data-off="OFF "></label>
                          <span>Angular JS</span>
                          </label>
                          <label class="switch switch-round block mt15 ">
<input type="radio " name="framework " id="fr3 " value="jquery ">
<label for="fr3 " data-on="ON " data-off="OFF "></label>
                          <span>jQuery</span>
                          </label>
                          <label class="switch switch-round block mt15 ">
<input type="radio " name="framework " id="fr4 " value="dojo " checked>
<label for="fr4 " data-on="ON " data-off="OFF "></label>
                          <span>Dojo</span>
                          </label>
                      </div>


                      <div class="hidden-xs col-md-3 ">
                          <label class="switch switch-round block mt15 ">
<input type="radio " name="framework2 " id="fr5 " value="mootols ">
<label for="fr5 " data-on="YES " data-off="NO "></label>
                          <span>MooTools</span>
                          </label>
                          <label class="switch switch-round block mt15 ">
<input type="radio " name="framework2 " id="fr6 " value="angular ">
<label for="fr6 " data-on="YES " data-off="NO "></label>
                          <span>Angular JS</span>
                          </label>
                          <label class="switch switch-round block mt15 ">
<input type="radio " name="framework2 " id="fr7 " value="jquery ">
<label for="fr7 " data-on="YES " data-off="NO "></label>
                          <span>jQuery</span>
                          </label>
                          <label class="switch switch-round block mt15 ">
<input type="radio " name="framework2 " id="fr8 " value="dojo " checked>
<label for="fr8 " data-on="YES " data-off="NO "></label>
                          <span>Dojo</span>
                          </label>
                      </div>

                  </div> -->
                    <!-- end .section row section -->


                    <!-- end .form-body section -->
                    <div class="panel-footer text-center ">
                        <button type="submit" class="button btn-primary "> Edit </button>
                    </div>
                    <!-- end .form-footer section -->
                </form>
            </div>
        </div>

    </div>
</div>
